import React, { useState } from 'react';
import axios from 'axios';
import BASE_URL from '../../config';
import './EventBooking.css';

const EventBookingDe = () => {
  const [form, setForm] = useState({
    first_name: '',
    last_name: '',
    company: '',
    email: '',
    phone: '',
    guests: '',
    address: '',
    date: '',
    start_time: '',
    end_time: '',
    message: '',
  });
  const [submitting, setSubmitting] = useState(false);
  const [result, setResult] = useState(null);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setResult(null);

    try {
      await axios.post(`${BASE_URL}/api/event-booking/`, form);
      setResult({ type: 'success', text: 'Vielen Dank! Ihre Buchungsanfrage wurde gesendet. Wir melden uns in Kürze bei Ihnen.' });
      setForm({
        first_name: '', last_name: '', company: '', email: '', phone: '',
        guests: '', address: '', date: '', start_time: '', end_time: '', message: '',
      });
    } catch (err) {
      const msg = err.response?.data?.error || 'Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.';
      setResult({ type: 'error', text: msg });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="evbook-page">
      <div className="evbook-hero">
        <h1 className="evbook-hero-title">Einen Barista für Ihr Event buchen</h1>
      </div>

      <div className="evbook-card">
        <h2 className="evbook-card-title">Wir freuen uns sehr über Ihre Eventanfrage!</h2>
        <p className="evbook-card-subtitle">
          Sobald wir Ihre Informationen erhalten haben, werden wir uns mit unserem Angebot bei Ihnen melden.
        </p>

        <form onSubmit={handleSubmit} className="evbook-form">
          <div className="evbook-row">
            <input name="first_name" value={form.first_name} onChange={handleChange} placeholder="Vorname" className="evbook-input" />
            <input name="last_name" value={form.last_name} onChange={handleChange} placeholder="Nachname *" required className="evbook-input" />
          </div>

          <input name="company" value={form.company} onChange={handleChange} placeholder="Firma" className="evbook-input evbook-full" />

          <div className="evbook-row">
            <input name="email" type="email" value={form.email} onChange={handleChange} placeholder="E-Mail *" required className="evbook-input" />
            <input name="phone" type="tel" value={form.phone} onChange={handleChange} placeholder="Telefon *" required className="evbook-input" />
          </div>

          <div className="evbook-row">
            <input name="guests" type="number" min="1" value={form.guests} onChange={handleChange} placeholder="Anzahl Personen *" required className="evbook-input" />
            <input name="address" value={form.address} onChange={handleChange} placeholder="Adresse des Events" className="evbook-input" />
          </div>

          <div className="evbook-field evbook-full">
            <label className="evbook-label">Datum *</label>
            <input name="date" type="date" value={form.date} onChange={handleChange} required className="evbook-input evbook-full" />
          </div>

          <div className="evbook-row">
            <div className="evbook-field">
              <label className="evbook-label">Event Beginn *</label>
              <select name="start_time" value={form.start_time} onChange={handleChange} required className="evbook-input">
                <option value="">Zeit wählen</option>
                {Array.from({ length: 24 }, (_, i) => { const t = `${String(i).padStart(2, '0')}:00`; return <option key={t} value={t}>{t}</option>; })}
              </select>
            </div>
            <div className="evbook-field">
              <label className="evbook-label">Event Ende *</label>
              <select name="end_time" value={form.end_time} onChange={handleChange} required className="evbook-input">
                <option value="">Zeit wählen</option>
                {Array.from({ length: 24 }, (_, i) => { const t = `${String(i).padStart(2, '0')}:00`; return <option key={t} value={t}>{t}</option>; })}
              </select>
            </div>
          </div>

          <textarea name="message" value={form.message} onChange={handleChange} placeholder="Nachricht" rows="4" className="evbook-input evbook-full evbook-textarea" />

          {result && (
            <div className={`evbook-result ${result.type}`}>{result.text}</div>
          )}

          <button type="submit" className="evbook-submit" disabled={submitting}>
            {submitting ? 'Wird gesendet…' : 'Absenden'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default EventBookingDe;
